import { useCallback } from 'react';
import { useSetCookie } from '../CookieContext.js';
import { useTrackingManager } from '../TrackingManagerContext.js';
import setTrackingPreference from '../utils/setTrackingPreference.js';
import useRequiredCategories from './useRequiredCategories.js';
const useSetTrackingPreference = () => {
  const _useTrackingManager = useTrackingManager(),
    region = _useTrackingManager.region,
    onPreferenceChange = _useTrackingManager.onPreferenceChange,
    onError = _useTrackingManager.onError;
  const setCookie = useSetCookie();
  const requiredCategores = useRequiredCategories();
  const changePreference = useCallback(preference => {
    const preferencesToSet = preference;
    // Do not remove category that's required
    requiredCategores.forEach(c => {
      if (!preference.consent.includes(c)) {
        onError(new Error(`Trying to remove category ${c} that is required`));
        preferencesToSet.consent = [...preference.consent, c];
      }
    });
    setTrackingPreference(setCookie, preferencesToSet, region, onPreferenceChange);
  }, [onPreferenceChange, region, setCookie, requiredCategores, onError]);
  return changePreference;
};
export { useSetTrackingPreference as default };
//# sourceMappingURL=useSetTrackingPreference.js.map
